import { TlscpLogEntry } from '@/generated/gql/graphql';
import { VirtualListProps } from '~/components/VirtualList/VirtualList';

import { DefaultBusinessLogItem } from './components/DefaultBusinessLogItem';
import { FileDownloadLogItem } from './components/FileDownloadLogItem';
import { SavingFieldLogItem } from './components/SavingFieldLogItem';

const specialLogItemComponentMap: Record<
  string,
  typeof DefaultBusinessLogItem | typeof FileDownloadLogItem | typeof SavingFieldLogItem
> = {
  'foundation-jet_report_creation_succeeded': FileDownloadLogItem,
  telescope_protocol_pdf_generated: FileDownloadLogItem,
  houston_saving_field_updated: SavingFieldLogItem,
} as const;

export const BusinessLogItem: NonNullable<VirtualListProps<TlscpLogEntry>['renderItem']> = ({ item, virtual }) => {
  const LogItemComponent = specialLogItemComponentMap[item.template] ?? DefaultBusinessLogItem;

  return <LogItemComponent item={item} virtual={virtual} />;
};
